import { useEffect } from 'react';

export default function SEO({ 
  title, 
  description, 
  keywords
}) {
  const baseTitle = 'Trid Enterprise Solutions';
  const pageTitle = title ? `${title} | ${baseTitle}` : `${baseTitle} | Oracle ERP Implementation`;
  const pageDescription = description || 'End to end Oracle ERP implementation, Cloud migration and Custom solutions for enterprise companies globally.';

  useEffect(() => {
    // Update document title
    document.title = pageTitle;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', pageDescription);
    }
    
    // Update meta keywords
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      }
    }
    
    // Update OG tags
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', pageTitle);
    }
    
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', pageDescription);
    }
  }, [pageTitle, pageDescription, keywords]);

  return null;
}
